module.exports = __webpack_public_path__ + "img/179.7f488d21.jpg";